<template>
    <div style="padding: 20px;">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <img src="@/assets/icon/wa.png" alt="" />
                <span>{{ isBind ? 'WhatsApp信息' : 'WhatsApp绑定' }}</span>
                <el-button v-show="isBind" type="text" @click="unBind" style="margin-left: auto;">解绑</el-button>
            </div>
            <div v-loading="infoLoading">
                <div v-if="isBind" style="display: flex;">
                    <el-avatar :size="48" :src="WaInfo.headImg ? WaInfo.headImg : circleUrl"></el-avatar>
                    <div style="margin-left: 12px;">
                        <div class="pItem">
                            <span>账号：</span>
                            <span class="value">{{WaInfo.account}}</span>
                        </div>
                        <div class="pItem">
                            <span>昵称：</span>
                            <span class="value">{{WaInfo.name}}</span>
                        </div>
                    </div>
                </div>
                <div v-else class="noBind">
                    <i class="el-icon-plus" @click="toBind"></i>
                </div>
            </div>
        </el-card>

        <el-dialog title="WhatsApp绑定" :visible.sync="dialogVisible" width="1240px">
            <iframe :src="bindUrl" frameborder="0" width="1200px" height="400px"></iframe>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            circleUrl: require("@/assets/img/headImg.png"),
            isBind: false,
            infoLoading: false,
            WaInfo: {},
            dialogVisible: false,
            bindUrl: "",
        };
    },
    methods: {
        //解绑WhatsApp账号
        unBind() {
            this.$confirm('解绑WhatsApp账号, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.get(this.$customerUrl + '/WhatsApp/UnBind').then((res) => {
                    const {isSuccess, data} = res;
                    if(isSuccess && data) {
                        this.$message({ type: 'success', message: '解绑成功!' });
                        this.getWaInfo();
                    }else{
                        this.$message({ type: 'warning', message: '解绑失败!' });
                    }
                });
            }).catch(() => {});
        },

        //获取绑定页面地址
        toBind(){
            this.$axios.get(this.$customerUrl + '/WhatsApp/BindUrl').then((res) => {
                const {isSuccess, data} = res;
                if(isSuccess && data) {
                    this.dialogVisible = true;
                    this.bindUrl = data;
                }
            });
        },

        //获取WhatsApp信息
        getWaInfo() {
            this.infoLoading = true;
            this.$axios.get(this.$customerUrl + '/WhatsApp/WaInfo').then((res) => {
                const {isSuccess, data} = res;
                this.infoLoading = false;
                if(isSuccess) {
                    if(data && data.account){
                        this.isBind = true;
                        this.WaInfo = data;
                    }else{
                        this.isBind = false;
                    }
                }
            });
        },

        handleIframeMessage(event) {
            if (event.data && event.data.action === 'closeIframe') {
                this.dialogVisible = false;
                this.getWaInfo();
            }
        },
    },
    mounted() {
        this.getWaInfo();
        window.addEventListener('message', this.handleIframeMessage);
    },
    destroyed() {
        window.removeEventListener('message', this.handleIframeMessage);
    },
};
</script>

<style lang='scss' scoped>
.box-card{
    width: 425px;
    height: 225px;
    .clearfix{
        display: flex;
        height: 28px;
        align-items: center;
        gap: 8px;
        font-weight: 600;
    }
    .pItem{
        font-size: 14px;
        color: #6a6a6a;
        height: 24px;
        line-height: 24px;
        .value{
            font-size: 16px;
            color: #303030;
        }
    }
    .noBind{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        .el-icon-plus{
            font-size: 32px;
            padding: 40px;
            border: 1px dashed #dcdfe6;
            cursor: pointer;
        }
    }
}
</style>